/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Note_ImportInputs */

const en_hub_note_import = /** @type {(inputs: Hub_Note_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Point Bystep at an existing specs folder or task file. It builds the plan — PRD, features, tasks, dependencies, acceptance — without spending a PRD credit.`)
};

const id_hub_note_import = /** @type {(inputs: Hub_Note_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arahkan Bystep ke folder specs atau berkas task yang sudah ada. Rencana dibentuk otomatis — PRD, fitur, task, dependensi, kriteria penerimaan — tanpa memotong kuota PRD.`)
};

/**
* | output |
* | --- |
* | "Point Bystep at an existing specs folder or task file. It builds the plan — PRD, features, tasks, dependencies, acceptance — without spending a PRD credit." |
*
* @param {Hub_Note_ImportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_note_import = /** @type {((inputs?: Hub_Note_ImportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Note_ImportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_note_import(inputs)
	return en_hub_note_import(inputs)
});